// extracted by mini-css-extract-plugin
export var carrierTab = "_4l-0";
export var carrierTabActive = "_4l-1 _4l-0";
export var carrierTabInactive = "_4l-2 _4l-0";
export var carrierTabLabel = "_4l-3";
export var carrierTabLabelActive = "_4l-4 _4l-3";
export var carrierTabLabelInactive = "_4l-5 _4l-3";
export var carrierTabPercentage = "_4l-6";
export var carrierTabPercentageActive = "_4l-7 _4l-6";
export var carrierTabPercentageInactive = "_4l-8 _4l-6";
export var carrierTabWinnable = "_4l-9";
export var carrierTabWinnableActive = "_4l-a _4l-9";
export var carrierTabWinnableInactive = "_4l-b _4l-9";
export var comparisonContainer = "_4l-d";
export var missingRateButton = "_4l-n";
export var missingRateButtonActive = "_4l-o _4l-n";
export var missingRateButtonInactive = "_4l-p _4l-n";
export var missingRateButtonLabel = "_4l-q";
export var missingRateButtonLabelActive = "_4l-r _4l-q";
export var missingRateButtonLabelInactive = "_4l-s _4l-q";
export var sidebar = "_4l-c";
export var strategyButton = "_4l-e";
export var strategyButtonActive = "_4l-f _4l-e";
export var strategyButtonDescription = "_4l-k";
export var strategyButtonDescriptionActive = "_4l-l _4l-k";
export var strategyButtonDescriptionInactive = "_4l-m _4l-k";
export var strategyButtonInactive = "_4l-g _4l-e";
export var strategyButtonLabel = "_4l-h";
export var strategyButtonLabelActive = "_4l-i _4l-h";
export var strategyButtonLabelInactive = "_4l-j _4l-h";
export var unitToggleButton = "_4l-t";
export var unitToggleButtonActive = "_4l-u _4l-t";
export var unitToggleButtonInactive = "_4l-v _4l-t";
export var unitToggleButtonLabel = "_4l-w";
export var unitToggleButtonLabelActive = "_4l-x _4l-w";
export var unitToggleButtonLabelInactive = "_4l-y _4l-w";